import * as yup from 'yup';

export const fdCalculatorSchema = yup.object().shape({
    investmentAmount: yup
        .number()
        .typeError('Investment amount must be a number')
        .min(1000, 'Minimum investment is ₹1,000')
        .max(10000000, 'Maximum investment is ₹10,00,00,000')
        .required('Investment amount is required'),

    interestRate: yup
        .number()
        .typeError('Interest rate must be a number')
        .min(1, 'Minimum interest rate is 1%')
        .max(15, 'Maximum interest rate is 15%')
        .required('Interest rate is required'),
    tenure: yup
        .number()
        .typeError('Tenure must be a number')
        .min(1, 'Minimum tenure is 1 year')
        .max(20, 'Maximum tenure is 20 years')
        .required('Time period is required'),
    totalInvested: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value)),

    estimatedReturns: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value)),

    totalValue: yup.number().transform((value) => (isNaN(value) ? 0 : value)),
});
